<app-inscription [currentPeriod]="currentPeriod" [members]="members"></app-inscription>
